













































































import Vue from "vue";

export default Vue.extend({
  name: "DefinedsizeControl.vue",
  data: () => ({
    items: ["Foo", "Bar", "Fizz", "Buzz"],
  }),
});
